import React, {useState} from 'react';

import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Label from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import {DateField} from '@mui/x-date-pickers/DateField';
import {Form} from '../../../types/form';

export const VEHICLE_TYPES = [
    {id: 10, label: 'Carreta'},
    {id: 6, label: 'Truck'},
    {id: 11, label: 'Toco'},
    {id: 8, label: 'Bitrem'},
    {id: 9, label: 'Ônibus'},
];

export type ExperienceProps = {
    values: Form,
    setValues: any,
    errors: Record<number, Record<string, string>>,
    index: number,
};


const ExperienceForm = (props: ExperienceProps) => {

    const {values, setValues, errors, index} = props;
    const [otherVehicleType, setOtherVehicleType] = useState<boolean>(values['experiences'][index]['other_vehicle_types'] !== '');

    const updateExperienceValues = (index: number, key: string, value: any) => {
        setValues({
            ...values,
            experiences: values['experiences'].map((experience, i) => {
                return i === index ? {...experience, [key]: value} : experience;
            }),
        });
    };

    const boxStyle = {
        border: '1px solid #ccc',
        borderRadius: 5,
        p: 3,
        my: 3,
    };

    return (
        <Stack
            direction={'column'}
            spacing={3}
            sx={index !== 0 ? boxStyle : {}}
        >
            {index !== 0 && (
                <Typography variant={'h2'}>
                    Experiência Profissional
                </Typography>
            )}

            <FormControl fullWidth>
                <Label
                    sx={{mb: 1}}
                >
                    {index === 0 ? 'Última empresa ou atual' : 'Nome da Empresa'} *
                </Label>
                <TextField
                    fullWidth
                    required={true}
                    variant={'outlined'}
                    value={values['experiences'][index]['company']}
                    onChange={(e) => updateExperienceValues(index, 'company', e.target.value)}
                />
            </FormControl>

            <FormControl fullWidth>
                <Label sx={{mb: 1}}>Veículos</Label>
                <FormGroup>
                    {VEHICLE_TYPES.map(vehicleType => (
                        <FormControlLabel
                            key={vehicleType.id}
                            label={vehicleType.label}
                            control={<Checkbox
                                size={'small'}
                                sx={{py: 0.3}}
                                checked={values['experiences'][index]['vehicle_types'].indexOf(vehicleType.id) !== -1}
                                onChange={(e) => {
                                    let vehicle_types = values['experiences'][index]['vehicle_types'];

                                    if (e.target.checked) {
                                        vehicle_types.push(vehicleType.id);
                                    } else {
                                        vehicle_types = vehicle_types.filter((id: number) => id !== vehicleType.id);
                                    }

                                    updateExperienceValues(index, 'vehicle_types', vehicle_types);
                                }}
                            />}
                        />
                    ))}
                    <FormControlLabel
                        label={'Outros'}
                        control={<Checkbox
                            size={'small'}
                            sx={{py: 0.3}}
                            checked={otherVehicleType}
                            onChange={(e) => {
                                updateExperienceValues(index, 'other_vehicle_types', '');
                                setOtherVehicleType(e.target.checked);
                            }}
                        />}
                    />
                    {otherVehicleType && (
                        <TextField
                            fullWidth
                            required={true}
                            variant={'outlined'}
                            placeholder={'Outros veículos'}
                            value={values['experiences'][index]['other_vehicle_types']}
                            onChange={(e) => {
                                setOtherVehicleType(true);
                                updateExperienceValues(index, 'other_vehicle_types', e.target.value);
                            }}
                            sx={{mt: 1}}
                        />
                    )}
                </FormGroup>
            </FormControl>

            <FormControl fullWidth>
                <Label sx={{mb: 1}}>Data de início *</Label>
                <DateField
                    value={values['experiences'][index]['start_date']}
                    onChange={newValue => updateExperienceValues(index, 'start_date', newValue)}
                    slotProps={{
                        textField: {
                            error: !!errors[index]?.start_date,
                            helperText: errors[index]?.start_date ?? '',
                        },
                    }}
                />
            </FormControl>

            <FormControl fullWidth>
                <Label sx={{mb: 1}}>Data de saída</Label>
                <DateField
                    value={values['experiences'][index]['end_date']}
                    onChange={newValue => updateExperienceValues(index, 'end_date', newValue)}
                    slotProps={{
                        textField: {
                            error: !!errors[index]?.end_date,
                            helperText: errors[index]?.end_date ?? '',
                        },
                    }}
                />
            </FormControl>

            <FormControl fullWidth>
                <Label sx={{mb: 1}}>Motivo do desligamento</Label>
                <TextField
                    fullWidth
                    variant={'outlined'}
                    value={values['experiences'][index]['resignation_reason']}
                    onChange={(e) => updateExperienceValues(index, 'resignation_reason', e.target.value)}
                />
            </FormControl>

            {index !== 0 && (
                <Stack
                    direction={'row'}
                    justifyContent={'end'}
                >
                    <Button
                        variant={'text'}
                        onClick={() => setValues({
                            ...values,
                            experiences: values['experiences'].filter((experience, i) => i !== index),
                        })}
                    >
                        Remover
                    </Button>
                </Stack>
            )}

        </Stack>
    );

};

export default ExperienceForm;